'use client';

import { useEffect, useState } from 'react';
import AdBanner from '../AdBanner';
import { getRuntimeAdCatalog } from '../utils/runtimeAdCatalog';

const AdSlot = ({ slotKey, ...uiProps }) => {
  const [runtimeSlot, setRuntimeSlot] = useState(null);

  useEffect(() => {
    let mounted = true;

    getRuntimeAdCatalog().then((catalog) => {
      if (!mounted) return;
      if (catalog && catalog[slotKey]) {
        setRuntimeSlot(catalog[slotKey]);
      }
    });

    return () => {
      mounted = false;
    };
  }, [slotKey]);

  const slot = runtimeSlot || null;

  if (!slot || !slot.href || !slot.imageSrc) {
    return null;
  }

  return (
    <AdBanner
      slotKey={slot.slotKey || slotKey}
      adId={slot.adId}
      href={slot.href}
      imageSrc={slot.imageSrc}
      alt={slot.alt || 'Advertisement'}
      openInNewTab={slot.openInNewTab !== false}
      useNextImage={Boolean(slot.useNextImage)}
      width={slot.width}
      height={slot.height}
      {...uiProps}
    />
  );
};

export default AdSlot;
